import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, custom, palette }: Theme) => ({
    formControl: {
      width: '100%',
    },
    radioGroup: {
      flexDirection: 'row',
      '&>*:first-child': {
        marginRight: 16,
      },
      [breakpoints.down(972)]: {
        flexDirection: 'column',
        '&>*:first-child': {
          marginRight: 0,
          marginBottom: 16,
        },
      },
    },
    tile: {
      display: 'flex',
      flex: 1,
      flexGrow: 1,
      margin: 0,
      padding: '8px 30px 8px 8px',
      border: `1px solid ${custom.grey[4]}`,
      borderRadius: 5,
      color: custom.grey[3],
      [breakpoints.down(1012)]: {
        padding: '8px',
      },
    },
    tileSelected: {
      color: palette.primary.main,
      borderColor: palette.primary.main,
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 400,
    },
    icon: {
      marginRight: 10,
      height: 20,
    },
    error: {
      border: `4px solid ${custom.status.danger.contrastText}`,
    },
  })
);
